import { Component, type ReactNode } from 'react';

// If anything throws during render, show a warm recovery card instead of a
// blank page — a kitchen tablet should never dead-end.
export class ErrorBoundary extends Component<{ children: ReactNode }, { broken: boolean }> {
  state = { broken: false };

  static getDerivedStateFromError() {
    return { broken: true };
  }

  componentDidCatch(error: unknown, info: { componentStack?: string | null }) {
    // keep the component stack in the console so a caught crash stays diagnosable
    console.error('render crashed', error, info?.componentStack ?? '(no component stack)');
  }

  render() {
    if (!this.state.broken) return this.props.children;
    return (
      <main className="flex min-h-dvh items-center justify-center px-6">
        <div className="max-w-sm text-center">
          <h1 className="font-serif text-4xl font-semibold tracking-tight">Cookbook</h1>
          <p className="mt-3 font-serif text-ink-soft">
            Something went sideways on this page. A refresh puts it right.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-5 h-12 w-full rounded-xl bg-ink font-sans text-[0.95rem] font-semibold text-paper transition-opacity hover:opacity-90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink"
          >
            Refresh the page
          </button>
        </div>
      </main>
    );
  }
}
